import React from 'react'
import PropTypes from 'prop-types'
import nl2br from 'react-nl2br'

import { List } from 'antd'
import FormattedMessage from 'components/FormattedMessage'
import CollapsibleContent from 'components/CollapsibleContent'

import './index.less'

const FrameContracts = ({ contracts }) => (
  <div className="provider-profile-page__content__frame-contracts">
    <h3 className="provider-profile-page__content__headline">
      <FormattedMessage id="providerProfilePage.mainContent.frameContracts.headline" />
    </h3>

    <List
      dataSource={contracts}
      renderItem={(contract, index) => (
        <List.Item key={index} className="provider-profile-page__content__frame-contracts__item">
          <div>
            <strong>{contract.preferred_partner_name}</strong>
            <CollapsibleContent collapsed={true} minHeight={295}>
              <p className="provider-profile-page__content__frame-contracts__description">
                {nl2br(contract.text)}
              </p>
            </CollapsibleContent>
          </div>
        </List.Item>
      )}
    />
  </div>
)

FrameContracts.propTypes = {
  contracts: PropTypes.arrayOf(
    PropTypes.shape({
      preferred_partner_name: PropTypes.string,
      text: PropTypes.string,
    }),
  ).isRequired,
}

export default FrameContracts
